import React from 'react';

interface ResizeOutlineIconProps {
  size?: number;
  color?: string;
}

const ResizeOutlineIcon: React.FC<ResizeOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5 8V12.5C13.5 12.7652 13.3946 13.0196 13.2071 13.2071C13.0196 13.3946 12.7652 13.5 12.5 13.5H1.5C1.23478 13.5 0.98043 13.3946 0.792893 13.2071C0.605357 13.0196 0.5 12.7652 0.5 12.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 0.5H13.5V4" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5 0.5L7 7" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ResizeOutlineIcon;
